import React, { useContext } from 'react';
import StyledComponent from 'styled-components';

import { DataManager, NavigationBarContext } from '../../components';
import { Colors } from '../../constant';

const HomeContainer = StyledComponent.div`
  .settings-close-btn
  {
    position: 'absolute',
    right: 8px;
    top: 8px;
    color: ${Colors.settings.closeButton.color}
  }
  margin-top: 10px;
`;

function Home() {
  const { selectedNavItem } = useContext(NavigationBarContext);
  return (
    <HomeContainer>
      {selectedNavItem !== null ? <DataManager model={selectedNavItem} /> : null}
    </HomeContainer>
  );
}

export default Home;
